export default __webpack_public_path__ + "static/media/calendar.960475ed.png";